/**
 * azadi-sale.js - Show the Azadi x Anniversary banner only when a
 * 50ML or 100ML variant is selected (Kalles / T4S theme).
 */
(function () {
  const SIZE_RE = /50\s?ML|100\s?ML/i;

  function init() {
    const banner = document.getElementById('azadi-banner');
    if (!banner) return false; // banner not in DOM yet, keep retrying

    const variantSelect = document.querySelector('select[name="id"]');

    // What size is currently selected?
    function isBottleSelected() {
      // Primary signal: the hidden variant select's option text (e.g. "50ML / Amber")
      if (variantSelect && variantSelect.selectedIndex > -1) {
        const text = variantSelect.options[variantSelect.selectedIndex].text || '';
        if (SIZE_RE.test(text)) return true;
        // If the select has real size options but none match, hide.
        if (variantSelect.options.length > 1) return false;
      }
      // Fallback for single-variant products (no size dropdown):
      // check the product title on the page.
      const title = document.querySelector('.product__title, .product-title, .pr_title, h1');
      return title ? SIZE_RE.test(title.textContent) : false;
    }

    function toggleBanner() {
      banner.style.display = isBottleSelected() ? 'flex' : 'none';
    }

    toggleBanner();

    // Direct change on the variant select
    if (variantSelect) variantSelect.addEventListener('change', toggleBanner);

    // Kalles updates variants via swatches/radios that don't always fire on the
    // hidden select, so listen broadly on the product form too.
    document.addEventListener('change', function (e) {
      const t = e.target;
      if (t && (t.name === 'id' || (t.closest && t.closest('[data-atc-form], form[action*="/cart/add"]')))) {
        // let Kalles finish updating the hidden select first
        setTimeout(toggleBanner, 50);
      }
    });

    return true;
  }

  // Kalles renders product content asynchronously, so retry until the
  // banner element appears (max ~5s), then stop.
  let tries = 0;
  const interval = setInterval(() => {
    if (init() || ++tries > 50) clearInterval(interval);
  }, 100);
})();